export const fieldLabels: Record<string, string> = {
  lastName: 'Фамилия',
  firstName: 'Имя',
  patronymic: 'Отчество',
  name: 'Логин',
  nickname: 'Позывной',
  phoneNumber: 'Номер телефона',
  birthDate: 'Дата рождения',
  region: 'Регион',
  team: 'Команда',
  vkLink: 'Ссылка на VK',
  rate: 'Разряд',
  qualification: 'Квалификация',
  status: 'Статус',
  hardwareId: 'Hardware ID',
  isActive: 'Активность',
  blockReason: 'Причина блокировки',
  accountStatus: 'Состояние аккаунта',
  delete: 'Удалить',
};
